import ApiService from '../apiservice'

export default class TituloAtividadeService extends ApiService {
  constructor() {
    super('/tituloAtividade');
  }

  cadastrar(titulo) {
    return this.post('/',titulo);
  }

  listar(empresa) {
    return this.get(`/all/${empresa}`);
  }

  consultar(codigo) {
    return this.get(`/${codigo}`);
  }

  consultarPorNome(nome,empresa) {
    return this.get(`/nome?nome=${nome}&empresa=${empresa}`);
  }

  alterar(titulo) {
    return this.put('/',titulo);
  }

  excluir(codigo) {
    return this.delete(`/${codigo}`);
  }
}